import React, { useCallback } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { ENDPOINT, Routes } from "../../../constants";
import ForgotPasswordForm from "../../../components/ForgotPasswordForm";
import { FetchApi } from "../../../api/fetch";

const ForgotPassword = React.memo(() => {
  const history = useHistory();

  const onFinish = useCallback(() => {
    toast.success("A verification code will be sent to you shortly.");
    history.push(Routes.CHANGE_PASSWORD);
  }, [history]);

  const onForgotPassword = async (email: string, actions: any) => {
    try {
      await FetchApi({
        endpoint: `${ENDPOINT.BASE_AUTH}/forgot-password`,
        method: "POST",
        body:  ({ email }),
      })

      onFinish()
    } catch (error: any) {
      actions.setSubmitting(false);
    }

  };


  return (
    <ForgotPasswordForm
      onFinish={onFinish}
      onForgotPassword={onForgotPassword}
    />
  );
});

export default ForgotPassword;
